import apiClient from './client';
import type { ColumnConfig } from '../components/ColumnSettings';

export interface UserSettings {
  column_settings?: ColumnConfig[];
  selected_team?: string | null;
  filters_collapsed?: boolean;
  personalization_collapsed?: boolean;
}

/**
 * Fetch user settings from backend
 */
export async function fetchUserSettings(): Promise<UserSettings> {
  const response = await apiClient.get('/users/me/settings');
  return response.data;
}

/**
 * Update user settings in backend
 */
export async function updateUserSettings(settings: Partial<UserSettings>): Promise<void> {
  await apiClient.put('/users/me/settings', settings);
}
